import axios from 'axios';
import qs from 'qs';
import { EXPRESS_INFO } from "./keys";
import { sort_ASCII } from "./util";
import md5 from 'js-md5'
import { Toast } from "vant";
const baseURL = 'http://pay.be.dev.myyixue.com/'
axios.defaults.withCredentials=false
const host = window.location.host,protocol= window.location.protocol;
const service = axios.create({
    baseURL,
    withCredentials: false,
    timeout: 30000, // request timeout
    headers: {
        'Content-Type': 'application/json'
    }
})
service.interceptors.request.use(function(config) {
    // if (JSON.parse(sessionStorage.getItem("EXPRESS_INFO") || "{}").expressToken) {
    //     config.headers.common["Express-Token"] = JSON.parse(sessionStorage.getItem("EXPRESS_INFO") || "{}").expressToken
    // }
    // if (config.params && (config.params instanceof Object) && !config.params.sign) {
    //     config.params["sign"] = md5(decodeURIComponent(sort_ASCII(config.params) + "yx_2020_express_dl"))
    // }
    // const params = config.data ? qs.parse(config.data) : {}
    // console.log(params,'3333')
    // // debugger
    // if (params && !params.sign) {
    //     const params = qs.parse(config.data)
    //     config.data = qs.stringify({
    //         ...params,
    //     })
    // }
    return Promise.resolve(config);
}, function(error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

service.interceptors.response.use(function(response) {
    let retData
    if (response.data.code === 100007) {
        retData = {
            ...response.data,
            message: '系统开小差了，刷新后再试'
        }
    } else {
        retData = {
            ...response.data
        }
    }
    return Promise.resolve(retData);
}, function (error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

class CRMAxios{
    constructor(options = {}) {
        this.options = options;
    }
    request(options) {
        return service.request(options);
    }
    testGet(url, options = {}) {
        return this.request({
            url: url,
            params: {
                ...options
            }
        })
    }
    testPost(url, data, options = {}) {

        // if (data instanceof Object) {
        //     data = qs.stringify(data);
        // }
        return this.request({
            method: 'post',
            url,
            data,
            ...options
        });
    }
}
const instanceAxios = new CRMAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const testGet = instanceAxios.testGet.bind(instanceAxios);
export const testPost = instanceAxios.testPost.bind(instanceAxios);

